import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ExecutionEnvironment from 'exenv';
import { RefreshIndicator } from 'material-ui';

import VendorDetailsRenderer from './VendorDetailsRenderer';
import VendorListRenderer from './VendorListRenderer';
import styles from './styles.scss';
import VendorListFilters from './VendorListFilters';

@connect(state => ({
  viewport: state.Responsive.get('viewport'),
  windowHeight: state.Responsive.get('windowHeight'),
}))
export default class Vendors extends React.Component {
  static propTypes = {
    viewport: PropTypes.string.isRequired,
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    windowHeight: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      onClient: false,
    };
  }

  componentWillMount() {
    this.setState({ onClient: ExecutionEnvironment.canUseDom });
  }

  componentDidMount() {
    this.setState({ onClient: true }); // eslint-disable-line
  }

  render() {
    const { viewport, match: {
      params: { vendorId: activeVendor },
    }, windowHeight } = this.props;
    const { onClient } = this.state;
    const top = ((windowHeight - 161) / 2) + 161;

    const ActiveVendor = <VendorDetailsRenderer activeVendor={activeVendor} />;

    if (viewport !== 'desktop' && activeVendor) {
      return ActiveVendor;
    }

    const loadingEl = (<div>
      <VendorListFilters updateFilter={() => null} />
      <RefreshIndicator top={top} left={277} status='loading' />
    </div>);

    return (<div className={styles.container}>
      <div className={styles.list}>
        {onClient ? <VendorListRenderer
          activeVendor={activeVendor}
          loadingEl={loadingEl}
        /> : loadingEl}
      </div>
      <div className={styles.detail}>{activeVendor ? ActiveVendor : null}</div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Vendors/Vendors.js